import React, { Fragment } from 'react';


type TransferApplicationStepperProps = {
  steps: {
    id: number,
    active: boolean,
    status: string,
    label: string
  }[]
}

const getStatusColor = (status: string) => {
  switch (status) {
    case 'Não preenchido':
      return 'gray'

    case 'Preenchido':
      return 'blue'

    case 'Em análise':
      return 'yellow'

    case 'Com pendências':
      return 'red'

    case 'Aprovado':
      return 'green'

    case 'Reprovado':
    case 'Eliminado':
      return 'red'

    default:
      return 'gray'
  }
}


const TransferApplicationStepper = ({ steps }: TransferApplicationStepperProps) => {
  return (
    <div className="stepper-header">
      {
        steps.map((step, index) => (
          <Fragment key={step.id}>
            <div className={`stepper-item ${step.active ? 'active' : ''}`}>
              <div className={`stepper-item-circle bg-${getStatusColor(step.status)}`} />
              <div className="stepper-item-text">{step.label}</div>
            </div>
            {
              (index + 1) < steps.length
              && <hr className="stepper-item-line" />
            }
          </Fragment>
        ))
      }
    </div>
  )
}

export default TransferApplicationStepper;
